export default __webpack_public_path__ + "static/MineralSwimV2_BENEFITS_HD1_1920x1000-2322eb21d1156949550a06fb18f10155.jpg";